import usePayrixMerchantId from './usePayrixMerchantId';
import usePayrixCustomerId from './usePayrixCustomerId';

type UsePayrixIds = {
  memberId: number | undefined;
};

export default function usePayrixIds({ memberId }: UsePayrixIds) {
  const { merchantId, isPending: isMerchantPending } = usePayrixMerchantId();
  const { customerId, isPending: isCustomerPending } = usePayrixCustomerId({ memberId });

  return { merchantId, customerId, isPending: isMerchantPending || isCustomerPending };
}
